import type {DeviceInfo} from '../../features/auth/repository/AuthRepository';

export class DeviceInfoService {
  private static instance: DeviceInfoService;

  private constructor () {}

  public static getInstance (): DeviceInfoService {
    if (!DeviceInfoService.instance) {
      DeviceInfoService.instance = new DeviceInfoService();
    }
    return DeviceInfoService.instance;
  }

  public async getDeviceInfo (): Promise<DeviceInfo> {
    try {
      return this.getWebDeviceInfo();
    } catch (error) {
      return this.getDefaultDeviceInfo();
    }
  }

  private getWebDeviceInfo (): DeviceInfo {
    const userAgent = navigator.userAgent || 'Unknown Browser';
    const platform = navigator.platform || 'Unknown Platform';
    const browserInfo = this.getWebBrowserInfo(userAgent);
    const deviceId = this.generateUniqueId();

    return {
      device_id: `web-${deviceId}`,
      device_type: 'WEB',
      device_name: browserInfo.name || 'Web Browser',
      device_os: platform || 'Web Platform',
      device_version: browserInfo.version || '1.0.0',
      ip_address: '127.0.0.1'
    };
  }

  private getWebBrowserInfo (userAgent: string): { name: string; version: string } {
    const browserInfo = {
      name: 'Web Browser',
      version: '1.0.0'
    };

    if (userAgent.includes('Chrome')) {
      browserInfo.name = 'Chrome';
      const match = userAgent.match(/Chrome\/(\d+\.\d+\.\d+\.\d+)/);
      if (match) {browserInfo.version = match[1];}
    } else if (userAgent.includes('Firefox')) {
      browserInfo.name = 'Firefox';
      const match = userAgent.match(/Firefox\/(\d+\.\d+)/);
      if (match) {browserInfo.version = match[1];}
    } else if (userAgent.includes('Safari')) {
      browserInfo.name = 'Safari';
      const match = userAgent.match(/Version\/(\d+\.\d+\.\d+)/);
      if (match) {browserInfo.version = match[1];}
    } else if (userAgent.includes('Edge')) {
      browserInfo.name = 'Edge';
      const match = userAgent.match(/Edge\/(\d+\.\d+\.\d+\.\d+)/);
      if (match) {browserInfo.version = match[1];}
    } else if (userAgent.includes('Opera')) {
      browserInfo.name = 'Opera';
      const match = userAgent.match(/OPR\/(\d+\.\d+\.\d+)/);
      if (match) {browserInfo.version = match[1];}
    }

    return browserInfo;
  }

  private generateUniqueId (): string {
    const timestamp = Date.now().toString(36);
    const randomStr = Math.random().toString(36).substring(2, 8);
    return `${timestamp}-${randomStr}`;
  }

  private getDefaultDeviceInfo (): DeviceInfo {
    const deviceId = this.generateUniqueId();
    return {
      device_id: `default-${deviceId}`,
      device_type: 'UNKNOWN',
      device_name: 'Unknown Device',
      device_os: 'Unknown OS',
      device_version: '1.0.0',
      ip_address: '127.0.0.1'
    };
  }
}
